import { useMemo } from 'react';
import { Panel } from '@bigcommerce/big-design';
import { ImageDropzone } from '../../../../components/ImageDropzone';
import { ORDER_ACTIONS } from '../hooks/useOrderEditState';
import { OrderComment } from './OrderComments';
import './Photos.css';

function toHexString(byteArray) {
	return Array.from(byteArray, (byte) =>
		`0${(byte & 0xff).toString(16)}`.slice(-2),
	).join('%');
}

function includeDataUriPrefix(imgB64) {
	// Make sure the photos contain the data uri prefix

	const re = new RegExp('^http');

	if (re.exec(imgB64)) return imgB64;

	if (imgB64.indexOf('data:image/') === -1) {
		// base64 to string
		const imgStr = atob(imgB64);

		// make byte array
		const bytes = Uint8Array.from(imgStr, (c) => c.charCodeAt(0));

		// transform input array into hex array
		return `data:image,%${toHexString(bytes)}`;
	}

	return imgB64;
}

export default function Photos({
	photos,
	photosRef,
	customerMessage,
	orderDispatch,
}) {
	const updatedPhotos = useMemo(
		() => photos.map(includeDataUriPrefix),
		[photos],
	);

	const hasPhotos = photos.some((photo) => photo.includes('http'));
	const countPhotos = photos.length;

	return (
		<Panel
			ref={photosRef}
			style={{ scrollMarginTop: '175px', color: hasPhotos ? 'red' : 'black' }}
			header={`Photos ${hasPhotos ? `(${countPhotos} photos have been uploaded)` : ''}`}
			marginTop="Large"
		>
			{customerMessage && (
				<OrderComment header="Customer Message">
					{customerMessage}
				</OrderComment>
			)}
			<ImageDropzone
				photos={updatedPhotos}
				onAddPhotos={(newPhotos) =>
					orderDispatch({
						type: ORDER_ACTIONS.ADD_PHOTOS,
						data: newPhotos,
					})
				}
				onRemovePhoto={(updatedPhotos) =>
					orderDispatch({
						type: ORDER_ACTIONS.REMOVE_PHOTO,
						data: updatedPhotos,
					})
				}
			/>
		</Panel>
	);
}
